import client from './client'
import system from './system'
import fileupload from './fileupload'
import project from './project'
import quote from './quote'
import resource from './resource'
import router from './router'
import snackbar from './snackbar'
import user from './user'
import payment from './payment'

const selectors = {
  router,
  system,
  fileupload,
  user,
  snackbar,
  project,
  client,
  quote,
  resource,
  payment,
}

export default selectors
